// Centralized date-fns locale imports for ESM compatibility
import { type Locale } from 'date-fns';
import { da, de, enAU, enCA, enGB, enIN, enNZ, enUS, enZA, es, fr, it, nl, pt, ptBR, sv } from 'date-fns/locale';

export const locales: Record<string, Locale> = {
  da,
  de,
  enAU,
  enCA,
  enGB,
  enIN,
  enNZ,
  enUS,
  enZA,
  es,
  fr,
  it,
  nl,
  pt,
  ptBR,
  sv,
};
